import PaymentSummary from './PaymentSummary';

const pad = (num: number) => {
  return ('00' + num).slice(-2);
};

class PaymentHistory {
  public readonly monthly: Map<string, Map<string, PaymentSummary[]>>;
  public readonly monthlyRate: Map<string, number>;
  constructor({
    monthly,
    monthlyRate,
  }: {
    monthly: Map<string, Map<string, PaymentSummary[]>>;
    monthlyRate: Map<string, number>;
  }) {
    this.monthly = monthly;
    this.monthlyRate = monthlyRate;
  }

  public static fromJSON = (value: any) => {
    if (typeof value !== 'object') throw new TypeError('monthly_total data struct is invalid');

    const monthly = new Map<string, Map<string, PaymentSummary[]>>();
    const monthlyRate = new Map<string, number>();

    value.forEach((data: any) => {
      ['all', 'pending', 'fixed', 'failed', 'paid'].forEach((key: any) => {
        const mm = data[key];
        if (!mm) return;
        if (typeof mm !== 'object') throw new TypeError(`monthly_total ${key} data struct is invalid`);
        mm.forEach((m: any) => {
          const month = new Date(Date.parse(m.data.service_month));
          if (month.toString() === 'Invalid Date') throw new TypeError('all service_month must be a Date');
          const monthStr = `${month.getFullYear()}${pad(month.getMonth() + 1)}`;
          if (!monthly.get(monthStr)) {
            monthly.set(monthStr, new Map<string, PaymentSummary[]>());
            monthlyRate.set(monthStr, data['from_usd_to_jpy_exchange_currency_rate']);
          }
          const monthlySummaries_ = monthly.get(monthStr);
          if (monthlySummaries_) {
            if (!monthlySummaries_.get(key)) {
              monthlySummaries_.set(key, []);
            }
            const monthlySummaries = monthlySummaries_.get(key);
            if (monthlySummaries) {
              monthlySummaries.push(PaymentSummary.fromJSON(m.data));
            }
          }
        });
      });
    });

    return new PaymentHistory({
      monthly,
      monthlyRate,
    });
  };
}

export default PaymentHistory;
